import { api } from "../http"
import type { FacilityShiftTime } from "./facilityModules"

export type FacilityDirectoryItem = {
  id: string
  name: string | null
  classification: string | null
}

export type FacilityCreatePayload = {
  id: string
  name: string
  classification?: string | null
  province?: string | null
  district?: string | null
  coordinates?: {
    latitude?: number | null
    longitude?: number | null
  } | null
  goLiveDate?: string | null
  trafficType?: string | null
  operatingHours?: string | null
  operationalNotes?: string | null
  shiftTimes?: FacilityShiftTime[] | null
}

export const facilitiesApi = {
  async list(): Promise<FacilityDirectoryItem[]> {
    return api.get<FacilityDirectoryItem[]>("/api/facilities")
  },

  async create(payload: FacilityCreatePayload): Promise<FacilityDirectoryItem> {
    return api.post<FacilityDirectoryItem, FacilityCreatePayload>("/api/facilities", payload)
  },
}
